import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ProfilePicIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.7782 3.22182C16.7006 1.14421 13.9382 0 11 0C8.06184 0 5.29942 1.14421 3.22182 3.22182C1.14421 5.29942 0 8.06184 0 11C0 13.9382 1.14421 16.7006 3.22182 18.7782C5.29942 20.8558 8.06184 22 11 22C13.9382 22 16.7006 20.8558 18.7782 18.7782C20.8558 16.7006 22 13.9382 22 11C22 8.06184 20.8558 5.29942 18.7782 3.22182ZM4.77406 18.4464C5.13728 15.321 7.82434 12.9081 11 12.9081C12.6741 12.9081 14.2483 13.5603 15.4325 14.7443C16.4329 15.7449 17.0638 17.0512 17.2261 18.4462C15.5392 19.8589 13.3673 20.7109 11 20.7109C8.63269 20.7109 6.46092 19.8591 4.77406 18.4464ZM11 11.5804C9.15788 11.5804 7.65901 10.0815 7.65901 8.23943C7.65901 6.39714 9.15788 4.89844 11 4.89844C12.8421 4.89844 14.341 6.39714 14.341 8.23943C14.341 10.0815 12.8421 11.5804 11 11.5804ZM18.3356 17.3565C18.0071 16.0322 17.3221 14.8111 16.3439 13.8329C15.5517 13.0407 14.6144 12.4463 13.5922 12.0739C14.821 11.2405 15.6301 9.83263 15.6301 8.23943C15.6301 5.68648 13.5529 3.60938 11 3.60938C8.44705 3.60938 6.36995 5.68648 6.36995 8.23943C6.36995 9.83347 7.17964 11.2419 8.40945 12.0751C7.46901 12.4178 6.59872 12.9477 5.84996 13.6453C4.76567 14.655 4.01271 15.9426 3.66359 17.3555C2.18503 15.651 1.28906 13.4282 1.28906 11C1.28906 5.64536 5.64536 1.28906 11 1.28906C16.3546 1.28906 20.7109 5.64536 20.7109 11C20.7109 13.4287 19.8146 15.652 18.3356 17.3565Z"
        fill="currentColor"
      />
    </svg>
  )
})

ProfilePicIcon.displayName = 'ProfilePicIcon'
